import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ga4Once } from "@/lib/ga4";
import AssessmentAgeSelect from "@/components/assessment/AgeSelect";
import { parseBand, bandParam } from "@/features/assessment-v2/band";
import type { AgeGroup } from "@/data/weekitQuestions";

/**
 * `/start` — the front door.
 *
 * Every paid learner lands here and picks their life stage. All three
 * stages are served by v2; the query string is built from `bandParam` so
 * the writer here and the parser in the assessment can never drift.
 */
export default function Start() {
  const navigate = useNavigate();
  // ConsentGate wraps /start, so anyone here is an adult or a consented minor.
  useEffect(() => { ga4Once("assessment_started", { source: "start" }); }, []);

  function handleSelect(age: AgeGroup) {
    const band = parseBand(age);
    // 18+ is the default band and takes no parameter — the assessment
    // resolves it from `parseBand(null)`, which is the same value.
    navigate(band === "18plus" ? "/assessment/v2" : `/assessment/v2?band=${bandParam(band)}`);
  }

  return <AssessmentAgeSelect onSelect={handleSelect} />;
}
